// frontend/source/portal/components/ConfirmDialog.js
import React from "react";
import "./ConfirmDialog.css";

const ConfirmDialog = ({
  isOpen,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  type = "danger", // danger, warning, info
}) => {
  if (!isOpen) return null;

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onConfirm();
    } else if (e.key === "Escape") {
      onCancel();
    }
  };

  return (
    <div
      className="confirm-dialog-overlay"
      onClick={onCancel}
      onKeyDown={handleKeyDown}
    >
      <div
        className="confirm-dialog-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="confirm-dialog-header">
          <div className={`confirm-dialog-icon ${type}`}>
            {type === "danger" && "⚠️"}
            {type === "warning" && "⚡"}
            {type === "info" && "ℹ️"}
          </div>
          <h2 className="confirm-dialog-title">{title}</h2>
        </div>

        <div className="confirm-dialog-content">
          <p className="confirm-dialog-message">{message}</p>
        </div>

        <div className="confirm-dialog-footer">
          <button
            onClick={onCancel}
            className="confirm-dialog-btn cancel-btn"
            autoFocus
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className={`confirm-dialog-btn confirm-btn ${type}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
